import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

import ChangeEmailContainer from './container';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const ContentChangeEmail = () => {
  const dispatch = useDispatch();
  const showChangeEmailModal = useSelector((state) => state.modalReducer.showChangeEmailModal);
  const showChangeEmailSuccessModal = useSelector((state) => state.modalReducer.showChangeEmailSuccessModal);
  const currentEmail = useSelector((state) => state.usersReducer.userProfile.email);
  const emailDomains = useSelector((state) => state.usersReducer.userProfile.officialEmailDomains);
  const emailExtensions = useSelector((state) => state.usersReducer.userProfile.officialEmailExtensions);
  const newEmail = useSelector((state) => state.usersReducer.newEmail);

  let showModal = showChangeEmailModal;

  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal user-change-email">
      <PopupHeader
        hideHelp={showChangeEmailSuccessModal}
        helpLink={APP.EXTERNAL_LINKS.MyProfile.ChangeEmail}
        title={APP.LANGUAGE.ChangeEmail.Title}
      />
      <div className="content">
        <div className={`${!showChangeEmailSuccessModal ? 'main-ui-container' : ''} user-change-email_container`}>
          {!showChangeEmailSuccessModal ? (
            <ChangeEmailContainer
              dispatch={dispatch}
              currentEmail={currentEmail}
              emailDomains={emailDomains}
              emailExtensions={emailExtensions}
            />
          ) : (
            <>
              <Container fluid as={Media} greaterThanOrEqual="tablet">
                <ShowChangeEmailSuccessModal newEmail={newEmail} />
              </Container>
              <Container fluid as={Media} at="mobile">
                <ShowChangeEmailSuccessModal isMobile newEmail={newEmail} />
              </Container>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

const ShowChangeEmailSuccessModal = ({ isMobile, newEmail }) => {
  const successMessage = APP.LANGUAGE.ChangeEmail.SuccessMessage;
  return (
    <div className={!isMobile ? 'pdlll pdrlll pdtl pdbl' : 'pdtl'}>
      {successMessage.map((message, i) => (
        <p key={`id_${message}_${i}`} className="mrbm">
          {message.replace('##newEmail##', newEmail)}
        </p>
      ))}
    </div>
  );
};

ContentChangeEmail.propTypes = {
  showChangeEmailModal: PropTypes.bool,
  showChangeEmailSuccessModal: PropTypes.bool,
  currentEmail: PropTypes.string,
  newEmail: PropTypes.string,
  emailDomains: PropTypes.string,
  emailExtensions: PropTypes.string,
};

ContentChangeEmail.defaultProps = {
  showChangeEmailModal: false,
  showChangeEmailSuccessModal: false,
  currentEmail: '',
  newEmail: '',
  emailDomains: '',
  emailExtensions: '',
};

export default ContentChangeEmail;
